<div
  class="online-status"
  [class.online]="onlineValue === 'online'"
  [class.offline]="onlineValue === 'offline'"
  [class.unavailable]="onlineValue === 'unavailable'"
  [style.width.px]="size"
  [style.height.px]="size"
></div>
